import type { CatalogueAsset } from '../services/catalogueActifsService';

type ViewMode = 'enfant' | 'parent';

interface CatalogueActifCardProps {
  asset: CatalogueAsset;
  isSelected: boolean;
  isHighlighted: boolean;
  viewMode: ViewMode;
  onClick: () => void;
}

export default function CatalogueActifCard({
  asset,
  isSelected,
  isHighlighted,
  viewMode,
  onClick,
}: CatalogueActifCardProps) {
  const state = isSelected ? 'selected' : isHighlighted ? 'highlighted' : 'normal';

  const base =
    'relative flex min-w-[108px] cursor-pointer flex-col items-center justify-center rounded-xl border-2 p-2.5 transition-all duration-200 ease-out';

  const highlightedStyle =
    viewMode === 'enfant'
      ? 'border-sky-500 bg-sky-100 text-sky-900 shadow-md ring-2 ring-sky-300 ring-offset-1'
      : 'border-rose-500 bg-rose-100 text-rose-900 shadow-md ring-2 ring-rose-300 ring-offset-1';

  const styles = {
    normal:
      'border-slate-200 bg-white text-slate-700 shadow-sm hover:border-slate-300 hover:bg-slate-50 hover:shadow',
    selected:
      'border-amber-500 bg-amber-100 text-amber-900 shadow-md ring-2 ring-amber-400 ring-offset-1',
    highlighted: highlightedStyle,
  };

  return (
    <div
      className={`${base} ${styles[state]}`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick();
        }
      }}
    >
      <div className="max-w-full px-1 text-center">
        <span className="text-xs font-medium leading-snug line-clamp-3">
          {asset.name}
        </span>
      </div>

    </div>
  );
}
